import { fetchApi } from '../../../../lib/fetchApi';
import { TemplateSelectDto, TemplatePagination, TemplateModelDto, TemplateFieldDto } from "../types";

const BASE_URL = "/template"

export const getTemplates = async (page: number, size: number, filter: string): Promise<TemplatePagination> => {
    const response = await fetchApi.get(`/template`, {
        params: {
            page,
            size,
            filter
        }
    }) as TemplatePagination;
    return response;
};

export const getTemplatesSelect = async (): Promise<TemplateSelectDto[]> => {
    const response = await fetchApi.get('/template/select') as TemplateSelectDto[];
    return response;
};

export const getTemplateById = async (idTemplate: string): Promise<TemplateModelDto> => {
    const response = await fetchApi.get(`/template/${idTemplate}`) as TemplateModelDto;
    return response
};

export const createTemplate = async (
    body: TemplateModelDto
): Promise<TemplateModelDto> => {
    const response = await fetchApi.post(`/template`, body) as TemplateModelDto;
    return response;
}

export const cloneTemplate = async (
    templateId: number
): Promise<TemplateModelDto> => {
    const response = await fetchApi.get<TemplateModelDto>(`${BASE_URL}/${templateId}/clone`);
    return response;
}

export const updateTemplate = async (idTemplate: string,  body: TemplateModelDto): Promise<TemplateModelDto> => {
    const response = await fetchApi.put(`/template/${idTemplate}`, body) as TemplateModelDto;
    return response;
}

export const deleteTemplate= async (idTemplate: number) => {
    const response = await fetchApi.delete(`/template/${idTemplate}`);
    return response;
};

export const getTemplateFieldsFromExcel = async (file: File) : Promise<TemplateFieldDto[]> => {
    const formData = new FormData();
    formData.append('File', file);

    return await fetchApi.post<TemplateFieldDto[]>(`${BASE_URL}/excel-template-fields`, formData);
}